import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Card, Form, Row, Col, Spinner, Modal } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";
import { IoIosClose } from "react-icons/io";
import { IoAdd, IoAddOutline } from "react-icons/io5";

const Company = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [companyname, setCompanyname] = useState("");
  const [contactperson, setcontactperson] = useState("");
  const [panno, setpanno] = useState("");
  const [workcontactno, setworkcontactno] = useState("");
  const [officecontactno, setofficecontactno] = useState("");
  const [gstno, setGstno] = useState("");
  const [email, setEmail] = useState("");
  const [address, setaddress] = useState("");
  const [address2, setaddress2] = useState("");
  const [country, setCountry] = useState(null);
  const [countryOptions, setCountryOptions] = useState([]);
  const [state, setState] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [city, setCity] = useState(null);
  const [cityOptions, setCityOptions] = useState([]);
  const [zipcode, setzipcode] = useState("");
  const [statecode, setstatecode] = useState(""); // State code state
  const [accountnumber, setaccountnumber] = useState("");
  const [bankname, setbankname] = useState("");
  const [branchname, setbranchname] = useState("");
  const [ifsccode, setifsccode] = useState("");
  const [policynumber, setpolicynumber] = useState("");
  const [policyvalidtill, setpolicyvalidtill] = useState("");

  const [cinno, setcinno] = useState("");
  const [lutno, setlutno] = useState("");
  const [udyamregistrationno, setudyamregistrationno] = useState("");
  const [iecno, setiecno] = useState("");
  const [incorporationdate, setincorporationdate] = useState("");

  const [formErrors, setFormErrors] = useState({
    branchname: false,
  });
  const [companyMultipleAddresses, setCompanyMultipleAddresses] = useState([
    {
      address: "",
      country: null,
      state: null,
      statecode: "",
      city: null,
      zipcode: "",
    },
  ]);
  const [files, setFiles] = useState([]);
  const [fetchedImagesId, setFetchedImagesId] = useState([]);
  const [fetchedImages, setFetchedImages] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [currentDoc, setCurrentDoc] = useState(null);
  const [imagesidfordelete, setimagesidfordelete] = useState([]);

  // Har word ka first letter capital karne ka function (Title Case)
  const capitalizeAllWords = (text) => {
    if (!text) return text;

    return text
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await axios.get(`${BASE_URL}company/findById/${1}`, {
          headers: authHeader(),
        });

        const Data = response.data;
        console.log("company data======>", Data);

        setpolicynumber(Data.policynumber);
        setpolicyvalidtill(Data.policyvalidtill);
        setCompanyname(Data.companyname);
        setworkcontactno(Data.workcontactno);
        setofficecontactno(Data.officecontactno);
        setGstno(Data.gstno);
        setEmail(Data.email);
        // setaddress(Data.address);
        // setaddress2(Data.address2);
        setcinno(Data.cinno);
        setlutno(Data.lutno);
        setudyamregistrationno(Data.udyamregistrationno);
        setiecno(Data.iecno);
        setincorporationdate(Data.incorporationdate);

        setcontactperson(Data.contactperson);
        setpanno(Data.panno);
        setstatecode(Data.statecode);
        setaccountnumber(Data.accountnumber);
        setbankname(Data.bankname);
        setbranchname(Data.branchname);
        setifsccode(Data.ifsccode);

        setFetchedImagesId(
          Data.companyImages.map((i) => ({
            id: i.id,
            name: i.filename,
            type: i.contenttype,
          }))
        );

        let addressData = await Promise.all(
          response.data.companyMultipleAddresses.map(async (i) => {
            let tempData = {
              address: i?.address,
              country: {
                value: i?.country?.id,
                label: i?.country?.countryname,
              },
              state: {
                value: i?.state?.id,
                label: i?.state?.statename,
                code: i?.state?.statecode,
              },
              statecode: i?.state?.statecode,
              city: { value: i?.city?.id, label: i?.city?.cityname },
              zipcode: i?.zipcode,
            };
            try {
              const stateResponse = await axios.get(
                BASE_URL + `state/stateByCountry/${i?.country?.id}`,
                {
                  headers: authHeader(),
                }
              );
              const cityResponse = await axios.get(
                BASE_URL + `city/cityByStateId/${i?.state?.id}`,
                {
                  headers: authHeader(),
                }
              );

              tempData.stateOptions = stateResponse?.data?.map((s) => ({
                value: s?.id,
                label: s?.statename,
              }));
              tempData.cityOptions = cityResponse?.data?.map((c) => ({
                value: c?.id,
                label: c?.cityname,
              }));
              return tempData;
            } catch (error) {
              console.log(error);
            }
          })
        );
        setCompanyMultipleAddresses(addressData);
        const countryResponse = await axios.get(
          BASE_URL + "country/findAllCountry",
          {
            headers: authHeader(),
          }
        );
        setCountryOptions(
          countryResponse.data.map((country) => ({
            value: country.id,
            label: country.countryname,
          }))
        );
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch  details. Please try again.",
        });
      }
    };

    fetch();
  }, [id]);

  useEffect(() => {
    if (fetchedImagesId.length > 0) {
      (async () => {
        let promises = fetchedImagesId.map(async (i) => {
          try {
            const response = await axios.get(
              BASE_URL + `companyImages/findById/${i.id}`,
              {
                headers: authHeader(),
                responseType: "blob",
              }
            );
            const contentType = response.headers["content-type"];
            const blob = new Blob([response.data], { type: contentType });
            const fileUrl = URL.createObjectURL(blob);
            return { src: fileUrl, name: i.name, type: i.type, id: i.id };
          } catch (error) {
            console.log("error in image fetch", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Failed to fetch or open file. Please try again.",
            });
          }
        });
        const imageUrls = await Promise.all(promises);
        setFetchedImages(imageUrls);
      })();
    }
  }, [fetchedImagesId]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(BASE_URL + "country/findAllCountry", {
          headers: authHeader(),
        });
        setCountryOptions(
          response.data.map((country) => ({
            value: country.id,
            label: country.countryname,
          }))
        );
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch countries. Please try again.",
        });
      }
    };
    fetchCountries();
  }, []);

  const addAddress = () => {
    setCompanyMultipleAddresses([
      ...companyMultipleAddresses,
      {
        address: "",
        country: null,
        state: null,
        statecode: "",
        city: null,
        zipcode: "",
      },
    ]);
  };

  const removeAddress = (index) => {
    const newAddresses = companyMultipleAddresses.filter((_, i) => i !== index);
    setCompanyMultipleAddresses(newAddresses);
  };

  const handleAddressChange = (index, field, value) => {
    const newAddresses = [...companyMultipleAddresses];
    // Capitalize all words if it's the address field
    if (field === "address") {
      value = capitalizeAllWords(value);
    }
    newAddresses[index][field] = value;
    setCompanyMultipleAddresses(newAddresses);
  };

  const handleCountryChange = async (index, selectedOption) => {
    let data = [...companyMultipleAddresses];
    data[index].country = selectedOption;

    let stateOpt = [];

    try {
      const response = await axios.get(
        BASE_URL + `state/stateByCountry/${selectedOption?.value}`,
        {
          headers: authHeader(),
        }
      );

      console.log("fetched country=========================>", response);

      stateOpt = response.data.map((state) => ({
        value: state.id,
        label: state.statename,
        code: state.statecode,
      }));
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch states. Please try again.",
      });
    }
    data[index].stateOptions = stateOpt;
    setCompanyMultipleAddresses(data);
  };

  const handleStateChange = async (index, selectedOption) => {
    let data = [...companyMultipleAddresses];
    data[index].state = selectedOption;
    data[index].statecode = selectedOption?.code || "";
    let cityOpt = [];
    try {
      const response = await axios.get(
        BASE_URL + `city/cityByStateId/${selectedOption.value}`,
        {
          headers: authHeader(),
        }
      );
      cityOpt = response.data.map((city) => ({
        value: city.id,
        label: city.cityname,
      }));
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch cities. Please try again.",
      });
    }
    data[index].cityOptions = cityOpt;
    setCompanyMultipleAddresses(data);
  };

  const handleSubmit = async () => {
    let formData = new FormData();
    let addressData = companyMultipleAddresses.map((i) => ({
      address: i?.address,
      country: { id: i?.country?.value },
      state: { id: i?.state?.value },
      statecode: String(i?.statecode),
      city: { id: i?.city?.value },
      zipcode: String(i?.zipcode),
    }));
    const companyData = {
      id: id,
      companyname,
      contactperson,
      panno,
      workcontactno,
      officecontactno,
      gstno,
      email,
      cinno,
      lutno,
      udyamregistrationno,
      iecno,
      incorporationdate,
      companyMultipleAddresses: addressData,
      accountnumber,
      bankname,
      branchname,
      ifsccode,
      policynumber,
      policyvalidtill,
      imagesidfordelete,
    };
    formData.append("company", JSON.stringify(companyData));
    if (files.length > 0) {
      files.forEach((file, index) => {
        formData.append("images", file); // Append each file with the key "images"
      });
    } else {
      formData.append(
        "images",
        new Blob([], { type: "application/octet-stream" })
      );
    }

    try {
      const response = await axios.put(
        `${BASE_URL}company/update/${1}`,
        formData,
        {
          headers: authHeader(),
        }
      );
      console.log("company post data", response.data);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Company updated successfully!",
      });
      navigate("/company");
    } catch (error) {
      console.log("error while submitting ", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data,
      });
    }
  };

  const handleCurrentFileView = (index) => {
    setCurrentDoc(fetchedImages[index]);
    setShowModel(true);
  };

  const handleCloseFileView = () => {
    setCurrentDoc(null);
    setShowModel(false);
  };

  const handleDownload = () => {
    if (currentDoc) {
      const link = document.createElement("a");
      link.href = currentDoc?.src;
      link.download = currentDoc?.name;
      link.click();
    }
  };

  const handleAddFile = (event) => {
    const file = event.target.files[0];
    setFiles((prev) => [...prev, file]);
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      const imageObject = {
        src: imageUrl,
        name: file.name,
        type: file.type,
      };
      setFetchedImages((prevImages) => [...prevImages, imageObject]);
    }
  };

  const handleRemoveDocument = (index) => {
    const img = fetchedImages[index];
    if (img?.id) {
      setimagesidfordelete((prev) => [...prev, img?.id]);
    } else {
      setFiles(prev => [...prev].filter(i => i.name !== img?.name))
    }
    setFetchedImages(fetchedImages.filter((i, ind) => ind !== index));
  };

  console.log("fetchedImages", fetchedImages);
  console.log("imagesidfordelete", imagesidfordelete);
  console.log("files", files);

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>COMPANY DETAILS EDIT</h6>
          <div className="view-buttons">
            <Link to={`/company`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group controlId="formcompanyname">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={companyname}
                    onChange={(e) => setCompanyname(capitalizeAllWords(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formcompanyname">
                  <Form.Label>Contact Person</Form.Label>
                  <Form.Control
                    type="text"
                    value={contactperson}
                    onChange={(e) => setcontactperson(capitalizeAllWords(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formphoneno">
                  <Form.Label>Work Contact No.</Form.Label>
                  <Form.Control
                    type="number"
                    value={workcontactno}
                    onChange={(e) => setworkcontactno(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formphoneno">
                  <Form.Label>Office Contact No.</Form.Label>
                  <Form.Control
                    type="number"
                    value={officecontactno}
                    onChange={(e) => setofficecontactno(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formemail">
                  <Form.Label>Email ID</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md="6">
                <Form.Group controlId="formgstno">
                  <Form.Label>Pan Card No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={panno}
                    onChange={(e) => setpanno(e.target.value.toUpperCase())}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formgstno">
                  <Form.Label>GST No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={gstno}
                    onChange={(e) => setGstno(e.target.value.toUpperCase())}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formgstno">
                  <Form.Label>Insurance Policy Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={policynumber}
                    onChange={(e) => setpolicynumber(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formgstno">
                  <Form.Label>Policy Valid Till</Form.Label>
                  <Form.Control
                    type="date"
                    value={policyvalidtill}
                    onChange={(e) => setpolicyvalidtill(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formgstno">
                  <Form.Label>CIN No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={cinno}
                    onChange={(e) => setcinno(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formgstno">
                  <Form.Label>LUT No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={lutno}
                    onChange={(e) => setlutno(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formgstno">
                  <Form.Label>Udyam Registration No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={udyamregistrationno}
                    onChange={(e) => setudyamregistrationno(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formgstno">
                  <Form.Label>IEC No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={iecno}
                    onChange={(e) => setiecno(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formgstno">
                  <Form.Label>Incorporation Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={incorporationdate}
                    onChange={(e) => setincorporationdate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formaddress">
                  <Form.Label>Account No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={accountnumber}
                    onChange={(e) => setaccountnumber(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formaddress">
                  <Form.Label>Bank Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={bankname}
                    onChange={(e) => setbankname(capitalizeAllWords(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formaddress">
                  <Form.Label>Branch Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={branchname}
                    onChange={(e) => setbranchname(capitalizeAllWords(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formaddress">
                  <Form.Label>IFSC Code</Form.Label>
                  <Form.Control
                    type="text"
                    value={ifsccode}
                    onChange={(e) => setifsccode(e.target.value.toUpperCase())}
                  />
                </Form.Group>
              </Col>
              {companyMultipleAddresses.map((addr, index) => (
                <div
                  key={index}
                  style={{ marginTop: "20px", marginBottom: "10px" }}
                >
                  <card className="card" style={{ padding: "10px" }}>
                    <Form.Label>Company Address</Form.Label>
                    <Row className="rowmulti">
                      <Col md="12">
                        <Form.Group controlId={`formsupplieraddress${index}`}>
                          <Form.Label>Address Line:</Form.Label>
                          <Form.Control
                            type="text"
                            value={addr?.address}
                            onChange={(e) =>
                              handleAddressChange(
                                index,
                                "address",
                                e.target.value
                              )
                            }
                            placeholder="Enter address line"
                          />
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group controlId={`formcountry${index}`}>
                          <Form.Label>Country:</Form.Label>
                          <Select
                            value={addr?.country}
                            onChange={(selectedOption) =>
                              handleCountryChange(index, selectedOption)
                            }
                            options={countryOptions}
                            placeholder="Select country"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group controlId={`formstate${index}`}>
                          <Form.Label>State:</Form.Label>
                          <Select
                            value={addr?.state}
                            onChange={(selectedOption) =>
                              handleStateChange(index, selectedOption)
                            }
                            options={addr?.stateOptions}
                            placeholder="Select state"
                            isDisabled={!addr.country}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group controlId={`formstatecode${index}`}>
                          <Form.Label>State Code:</Form.Label>
                          <Form.Control
                            type="text"
                            value={addr?.statecode}
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group controlId={`formcity${index}`}>
                          <Form.Label>City:</Form.Label>
                          <Select
                            value={addr?.city}
                            onChange={(selectedOption) =>
                              handleAddressChange(index, "city", selectedOption)
                            }
                            options={addr?.cityOptions}
                            placeholder="Select city"
                            isDisabled={!addr.state}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group controlId={`formpincode${index}`}>
                          <Form.Label>Zipcode No.:</Form.Label>
                          <Form.Control
                            type="text"
                            value={addr?.zipcode}
                            onChange={(e) =>
                              handleAddressChange(
                                index,
                                "zipcode",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </Col>
                      {companyMultipleAddresses?.length > 1 && (
                        <Col md="4">
                          <button
                            style={{
                              marginTop: "40px",
                              marginLeft: "px",
                              height: "38px",
                            }}
                            type="button"
                            onClick={() => removeAddress(index)}
                            className="btn btn-danger"
                          >
                            Remove
                          </button>
                        </Col>
                      )}
                    </Row>
                    <br />
                  </card>
                </div>
              ))}
              <Col md="12">
                <button
                  style={{ width: "250px", marginLeft: "0px" }}
                  type="button"
                  onClick={addAddress}
                  className="btn btn-primary mt-3 mb-3"
                >
                  + Add Another Address
                </button>
              </Col>

              <Row className="rowmulti">
                <Form.Label>Documents:</Form.Label>
                {fetchedImages.map((i, index) => {
                  return (
                    <Col md="2" className="" key={index} title={i.name}>
                      <div className="document-container">
                        <img
                          className="document-img"
                          src={
                            i.type === "application/pdf"
                              ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQFD8wlKNXDLaQd2isyyR0pzjfs3rhEoYcI19JN8mjTknETmghvZ_ux3Jr9RFvcZ4IXGmA&usqp=CAU"
                              : i.src
                          }
                          alt={i.name}
                        />
                        <div
                          className="close-icon-img"
                          onClick={(e) => handleRemoveDocument(index)}
                        >
                          <IoIosClose
                            style={{ color: "white", strokeWidth: "2rem" }}
                          />
                        </div>
                      </div>
                      <p className="p-2">
                        {i.name.length > 12
                          ? i.name.slice(0, 12) + "..."
                          : i.name}
                      </p>
                    </Col>
                  );
                })}
                <Col md="2" className="">
                  <label htmlFor="images" className="file-upload-label">
                    <div className="file-upload-icon-container">
                      <IoAddOutline size={50} />
                    </div>
                  </label>
                  <input
                    id="images"
                    type="file"
                    className="visually-hidden"
                    accept=".jpg, .jpeg, .png, .pdf"
                    onChange={handleAddFile}
                  />
                </Col>
              </Row>
            </Row>
            <button className="button-70" type="button" onClick={handleSubmit}>
              SUBMIT
            </button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Company;